import PaymentMethodRender from './PaymentMethodRender'

export default PaymentMethodRender
